import { MutationResponse } from '@/api/types/common.types';

export enum PaymentMethod {
  Card = 'CARD',
  Wallet = 'WALLET',
  My_card = 'MY_CARD',
  Portmanat = 'PORTMANAT',
  Terminal = 'TERMINAL',
}

export enum PaymentProvider {
  Azericard = 'AZERICARD',
  Goldenpay = 'GOLDENPAY',
  Kapitalbank = 'KAPITALBANK',
  Yigim = 'YIGIM',
}

export enum TerminalPaymentTargetType {
  Ad = 'ad',
  Invoice = 'invoice',
  Balance = 'balance',
}

export enum PaymentService {
  Add_balance_custom = 'add_balance_custom',
}

export enum PaymentStatus {
  Success = 'success',
  Failure = 'failure',
  Duplicate = 'duplicate',
  ContinueToWebsite = 'continue_to_website',
}

export enum PaymentReferrer {
  Mobile_ad_prolong_promo = 'MOBILE_AD_PROLONG_PROMO',
  Miniapp_ad_prolong_promo = 'MINIAPP_AD_PROLONG_PROMO',
}

type PaymentResult = {
  status: PaymentStatus;
  redirectUrl?: string;
  paymentLegacyId?: string;
  paymentDate?: string;
  targetLegacyId?: string;
  provider: PaymentProvider;
};

export type CreatePaymentResponse = {
  createPayment: MutationResponse<PaymentResult>;
};

export type CreateTerminalPaymentResponse = {
  createTerminalPayment: MutationResponse<boolean>;
};
